import Page from './Details.vue';
export default Page;
